import { styled } from "@mui/material";

export const ContentArea = styled("main")(({ theme }) => ({
  boxSizing: "border-box",
  paddingLeft: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    paddingLeft: `calc(${theme.spacing(8)} + 1px)`,
  },
}));
